<template>
  <div>
    <div class="content-block">
      <h5>Log Aktivitas User</h5>
    </div>

    <div class="content-block" v-if="summaryLogData">
      <div class="dx-card responsive-paddings">
        <div class="header-inline">
          <p class="text-muted font-weight-light fs-6 fw-bold mb-0">
            Rangkuman Aktivitas User
            <!-- {{ commonFunction.getCurrentMonthIndonesia() }}
            {{ commonFunction.getCurrentYear() }} -->
          </p>

          <DxDateBox
            class="periode-datebox"
            :styling-mode="stylingMode"
            :label-mode="'hidden'"
            display-format="MMMM yyyy"
            type="date"
            picker-type="calendar"
            :open-on-field-click="true"
            :calendar-options="{
              maxZoomLevel: 'year',
              minZoomLevel: 'year',
            }"
            v-model:value="summaryLogPeriod"
            @value-changed="onSummaryLogPeriodChanged"
          />
        </div>

        <ActivityUserRankTemplate :userData="summaryLogData" />
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="activityLogListStore.dataSourceActivityLogList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :filter-value="filterValue"
          :filter-sync-enabled="true"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
        >
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
          />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxColumnFixing :enabled="false" />

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            data-type="number"
          />

          <DxColumn
            data-field="activity_log_id"
            caption="ID"
            :allowHeaderFiltering="false"
            :visible="false"
          >
          </DxColumn>

          <DxColumn
            data-field="causer_id"
            caption="User ID"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <DxColumn
            data-field="users_name"
            caption="User Name"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="log_name"
            caption="Log Name"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="description"
            caption="Description"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="subject_id"
            caption="Subject ID"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="properties"
            caption="Properties"
            :allowHeaderFiltering="false"
            cell-template="template-properties"
            width="400px"
          >
          </DxColumn>

          <DxColumn
            data-field="parent_type"
            caption="Parent"
            :allowHeaderFiltering="true"
          >
          </DxColumn>

          <DxColumn
            data-field="parent_id"
            caption="Parent ID"
            :allowHeaderFiltering="true"
          >
          </DxColumn>
          <!-- :calculate-cell-value="(row) => JSON.stringify(row.properties)" -->

          <template #template-properties="{ data }">
            <pre style="white-space: pre-wrap; word-break: break-word">
  {{ JSON.stringify(data.value, null, 2).trim() }}
</pre
            >
          </template>

          <DxColumn
            caption="Created At"
            :allowHeaderFiltering="false"
            data-field="activity_log_created_at"
            cell-template="template-created-at"
          />

          <!-- <DxColumn
            caption="Created At TANPA CONVERT"
            :allowHeaderFiltering="false"
            data-field="activity_log_created_at"
          /> -->

          <!-- <DxColumn
            caption="Updated At"
            :allowHeaderFiltering="false"
            data-field="activity_log_updated_at"
            cell-template="template-updated-at"
          />

          <DxColumn
            caption="Event"
            :allowHeaderFiltering="false"
            data-field="event"
          />

          <DxColumn
            caption="Batch UUID"
            :allowHeaderFiltering="false"
            data-field="batch_uuid"
          /> -->

          <template #template-created-at="{ data }">
            <div v-html="data.data.created_at_text"></div>
          </template>

          <template #template-updated-at="{ data }">
            <div v-html="data.data.updated_at_text"></div>
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style scoped>
.header-inline {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.periode-datebox {
  width: 180px; /* control size here */
}
</style>

<script>
import * as commonFunction from "@/utils/common-function.js";
import { BASE_URL } from "@/global-constants";
import { useActivityLogListStore } from "@/stores/views/activity-log-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import api from "@/api";
import ActivityUserRankTemplate from "./ActivityUserRankTemplate.vue";
const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];
import { DateTime } from "luxon";
/* eslint-disable */
export default {
  components: {
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    ActivityUserRankTemplate,
  },
  setup() {
    const activityLogListStore = useActivityLogListStore();
    const commonStore = useCommonStore();
    activityLogListStore.dataSourceActivityLogList.filter(null);
    return {
      activityLogListStore,
      commonStore,
      commonFunction,
    };
  },
  data() {
    const vm = this;
    return {
      summaryLogPeriod: commonFunction.getStartOfCurrentMonth(),
      summaryLogData: [],
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      filterValue: [],
      options: options,
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    this.activityLogListStore.initialized;
    this.summaryLogData = await this.getLogSummary();

    // await this.commonStore.preloadStores();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    async onSummaryLogPeriodChanged(e) {
      const date = DateTime.fromJSDate(new Date(e.value)).toISODate();
      this.summaryLogData = await this.getLogSummary(date);
    },
    async getLogSummary(tgl = null) {
      try {
        const res = await api.post("/get-log-summary", { tgl });

        return res.data;
      } catch (error) {
        console.error("getlogsummary failed:", error);
        throw error;
      }
    },
    displayPenyesuaian(e) {
      if (e.data.status_penyesuaian) return "Penyesuaian";
      return "";
    },
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },

    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    async refreshDatagrid(gridRef) {
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
      this.summaryLogData = await this.getLogSummary();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Log Aktivitas User");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Log Aktivitas User.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
